import React, { Component } from "react";
import { FormGroup, Col, Label, Button } from "reactstrap";
import { Redirect } from "react-router-dom";
import { getAllResources } from "../../../../action/cultureAction";
import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import CalendarGif from "../../../..//Assets/images/Calendar.gif";
import DatePicker from "react-datepicker";
import Conversions from "../../../../Resources/Conversions";
import TimePicker from "rc-time-picker";
import { FaClock } from "react-icons/fa";
import moment from "moment";
import { Icon } from "semantic-ui-react";
import RemoveIcon from "../../../../Assets/icons/col_del_16.png";
import { getSchedulesRecurrenceList } from "../../../../action/ReportManagement/ScheduleReport";
import { returnScheduleListValue } from "../DataExport/GetScheduleListValue";
import { month, week, period } from "../DataExport/common";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import DataExportHeader from "./DataExportHeader";

class ExportRecurrence extends Component {
  componentWillMount() {
    if (
      this.props.getLabels === undefined ||
      this.props.getLabels["WorkOrders.Columns.Record.Text"] === undefined
    ) {
      this.props.getAllResources();
    }
    var IsFromReportSchedules;
    IsFromReportSchedules = sessionStorage.getItem("IsFromReportSchedules");
    if (
      IsFromReportSchedules !== undefined &&
      IsFromReportSchedules !== null &&
      IsFromReportSchedules === "true"
    ) {
      this.setState({ IsFromReportSchedules: true });
    }
    var SelectedReportDetails;
    SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
    if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
      var details = JSON.parse(SelectedReportDetails);
      this.setState({
        reportType: details.type,
        reportId: details.id,
        reportNameValue: details.name,
      });
      this.props.getSchedulesRecurrenceList(details.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        ScheduleRecurrenceList: nextProps.scheduleRecurrenceDetails,
        ScheduleReportList: nextProps.scheduleReportDetails,
      });

      if (
        this.state.reportId > 0 &&
        nextProps.scheduleRecurrenceDetails !== null &&
        nextProps.scheduleRecurrenceDetails.length > 0 &&
        nextProps.scheduleReportDetails !== null &&
        nextProps.scheduleReportDetails.calendarEntries !== null &&
        nextProps.scheduleReportDetails.calendarEntries.length > 0
      ) {
        let returnvalue = [];
        returnvalue = returnScheduleListValue(
          nextProps.scheduleRecurrenceDetails,
          nextProps.scheduleReportDetails,
          this.props.getLabels,
          this.props.UserPreference_response
        );

        let EditRecDays = returnvalue;
        let Calendarvalues = [];

        this.setState({
          isDateSelected: true,
        });

        this.props.setArchiveEmailVal(true);

        this.setState({ ExportRecurrenceList: EditRecDays });
        if (returnvalue.length > 0) {
          for (var i = 0; i < returnvalue.length; i++) {
            if (returnvalue[i].calendarEntries !== null) {
              Calendarvalues.push(returnvalue[i].calendarEntries);
            }
          }
          this.setState({ calendarEntries: Calendarvalues });
          this.setState({ isDatePresent: true });
        }
      }
    }
  }

  static propTypes = {
    toggle: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      redirectBack: false,
      isOpen: false,
      startDateRec: null,
      isAddDisabled: false,
      startTimeRec: "",
      openRec: false,
      isSingleDate: true,
      isDateRange: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: false,
      fromDateRec: null,
      toDateRec: null,
      EffectiveDaysString: "",
      WeekCollection: [],
      IsdisableMonthly1: false,
      IsdisableMonthly3: true,
      IsdisableYearly1: false,
      IsdisableYearly3: true,
      IsValid: true,
      isDateSelected: false,
      isDatePresent: false,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      IsFromReportSchedules: false,
      ScheduleRecurrenceList: [],
      ScheduleReportList: [],
      reportId: 0,
      isExcelChecked: true,
      createFileAlways: true,
      isFileCreated: false,
      IsDisableExcelRdButton: true,
      ExportRecurrenceList: [],
      deletedReportScheduleId: [],
      calendarEntries: [],
      reportType: 0,
      AmplitudeRecurrenceList: [],
      reportNameValue: "",
      recurringMonthly: false,
      recuringPeriod: false,
      isEdit: false,
      recurringYearlyMonth: false,
      yearlyDateRadio: true,
      recurringYearlyMonthly: "",
      recurringYearlyPeriods: "",
      recurringWeekDays: "",
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
      SchCkPDF: true,
      SchCkExcel: false,
      recDay: "",
      recurrencePeriod: "",
      recurrenceWeekDay: "",
      recurrenceDate: true,
      recurringYearlyDays: "", 
      recurringYearlyMonths: "",
    };
    this.OnNext = this.OnNext.bind(this);
    this.goBack = this.goBack.bind(this);
    this.OnCancel = this.OnCancel.bind(this);
    this.ToggleAddButton = this.OnToggleAddButton.bind(this);
    this.ToggleCancelButton = this.OnToggleCancelButton.bind(this);
    this.handleChangeRec = this.handleChangeRec.bind(this);
    this.handleValueChangeRec = this.handleValueChangeRec.bind(this);
    this.FromDateChangeRec = this.FromDateChangeRec.bind(this);
    this.ToDateChangeRec = this.ToDateChangeRec.bind(this);
    this.handleSingleDate = this.handleSingleDate.bind(this);
    this.handleDateRange = this.handleDateRange.bind(this);
    this.handleWeekly = this.handleWeekly.bind(this);
    this.handleMonthly = this.handleMonthly.bind(this);
    this.handleYearly = this.handleYearly.bind(this);
    this.handleMonthlyRecurDate = this.handleMonthlyRecurDate.bind(this);
    this.handleMonthlyRecurMonth = this.handleMonthlyRecurMonth.bind(this);
    this.handleMonthlyRecurPeriod = this.handleMonthlyRecurPeriod.bind(this);
    this.handleYearlyRecurDate = this.handleYearlyRecurDate.bind(this);
    this.handleYearlyRecurMonth = this.handleYearlyRecurMonth.bind(this);
    this.handleYearlyRecurPeriod = this.handleYearlyRecurPeriod.bind(this);
    this.handleExcelChange = this.handleExcelChange.bind(this);
    this.handlePDFChange = this.handlePDFChange.bind(this);
    this.handlerdNewExcelChange = this.handlerdNewExcelChange.bind(this);
    this.handlerdReuseExcelChange = this.handlerdReuseExcelChange.bind(this);
  }

  OnNext(tab) {
    const { toggle } = this.props;
    toggle(tab);
    var RecurrenceList = [],
      calendarEntries = [],
      deletedReportScheduleIds = [];

    this.state.ExportRecurrenceList.forEach((el) => {
      let TMP = {
        ReportScheduleId: el.reportScheduleId,
        ReportId: this.state.reportId,
        Interval: el.interval,
        Hour: el.hour,
        Minute: el.minute,
        Month: el.month,
        Day: el.day,
        DaysOfWeek: el.daysOfWeek,
        Modifier: el.modifier,
        CreatePDF: el.createPDF,
        CreateExcel: el.createExcel,
        CreateFileAlways: el.createFileAlways,
        IsFileCreated: el.isFileCreated,
        CreateCSV: el.createCSV,
      };      
      
      let TMP1 = {
        ReportCalendarId: el.calendarEntries.reportCalendarId,
        ReportId: this.state.reportId,
        IsExclusion: el.calendarEntries.isExclusion,
        IsStartDateTime: el.calendarEntries.isStartDateTime,
        Offset: el.calendarEntries.offset,
        From: el.calendarEntries.range.from,
        To: el.calendarEntries.range.to,
      };
      calendarEntries.push(TMP1);
      RecurrenceList.push(TMP);
    });

    this.state.deletedReportScheduleId.forEach((el) => {
      let TMP2 = {
        ReportScheduleId: el.reportScheduleId,
        ReportId: this.state.reportId,
      };
      deletedReportScheduleIds.push(TMP2);
    });

    var Data = {
      ExportRecurrenceList: RecurrenceList,
      deletedReportScheduleId: deletedReportScheduleIds,
      calendarEntries: calendarEntries,
      ReportType: this.state.reportType,
      AmplitudeRecurrenceList: this.state.AmplitudeRecurrenceList,
    };

    if (this.state.ExportRecurrenceList.length === 0) {
      this.props.setArchiveEmailVal(false);
    } else {
      this.props.setArchiveEmailVal(true);
    }

    this.props.setExportRecurrence(Data);
  }

  goBack(tab) {
    this.setState({ IsValid: true, IsNoDate: false, IsNoTime: false, IsNoWeekly: false });
    this.props.toggle(tab);
  }

  OnCancel() {
    this.resetData();
    this.setState({ redirectBack: true, ScheduleRecurrenceList: [] });
  }
  
  resetData() {
    this.setState({
      isAddDisabled: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isEdit: false,
      startDateRec: null,
      isSingleDate: true,
      isDateRange: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: false,
      recurringMonthly: false,
      recuringPeriod: false,
      startTimeRec: "", 
      timeRec: "", 
      recurringYearlyMonthly: "",
      recurringYearlyPeriods: "",
      recurringWeekDays: "",
      isFromDateRangeGreaterError: false,
      Sunday: false,
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      recurringYearlyMonth: false,
      yearlyDateRadio: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      SchCkPDF: true,
      SchCkExcel: false,
      recDay: "1",
      recurrencePeriod: "1",
      recurrenceWeekDay: "1",
      recurrenceDate: true,
      recurringYearlyDays: "1", 
      recurringYearlyMonths: "1",
      IsdisableYearly1: false,
      IsdisableYearly3: true,
      isExcelChecked: true,
      createFileAlways: true,
      isFileCreated: false,
      fromDateRec: null,
      toDateRec: null,
      isCSVChecked: false,
    });

    if (this.refs.Monthly !== undefined) {
      this.refs.Monthly.checked = false;
    }

    if (this.refs.Weekly !== undefined) {
      this.refs.Weekly.checked = false;
    }

    if (this.refs.Yearly !== undefined) {
      this.refs.Yearly.checked = false;
    }

    if (this.refs.RecurYearlyDate !== undefined) {
      this.refs.RecurYearlyDate.checked = false;
    }

    if (this.refs.RecurDate !== undefined) {
      this.refs.RecurDate.checked = false;
    }

    if (this.refs.SingleDate !== undefined) {
      this.refs.SingleDate.checked = true;
    }

    if (this.refs.DateRange !== undefined) {
      this.refs.DateRange.checked = false;
    }

    if (this.refs.SchCkPDF !== undefined) {
      this.refs.SchCkExcel.checked = false;
      this.refs.SchCkPDF.checked = true;
    }
  }

  OnToggleAddButton() {
    this.setState({
      isOpen: true,
      isAddDisabled: true,
      startDateRec: null,
      isSingleDate: true,
      isDateRange: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
    this.resetData();
  }

  OnToggleCancelButton() {
    this.resetData();
    this.setState({ isOpen: false, isAddDisabled: false });
  }

  handleChangeRec(date) {
    this.setState({ startDateRec: date });
  }

  FromDateChangeRec(date) {
    this.setState({ fromDateRec: date });
  }

  ToDateChangeRec(date) {
    this.setState({ toDateRec: date });
  }

  handleValueChangeRec = (value) => {
    this.setState({ startTimeRec: value });
  };

  setOpenRec = ({ open }) => {
    this.setState({ openRec: true });
  };

  setCloseRec = ({ open }) => {
    this.setState({ openRec: false });
  };

  handleSingleDate() {
    this.setState({
      isSingleDate: true,
      isDateRange: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime:false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
  }

  handleDateRange() {
    this.setState({
      isSingleDate: false,
      isDateRange: true,
      isWeekly: false,
      isMonthly: false,
      isYearly: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
  }

  handleWeekly() {
    this.setState({
      isSingleDate: false,
      isDateRange: false,
      isWeekly: true,
      isMonthly: false,
      isYearly: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
  }

  handleMonthly() {
    this.setState({
      isSingleDate: false,
      isDateRange: false,
      isWeekly: false,
      isMonthly: true,
      isYearly: false,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
  }

  handleYearly() {
    this.setState({
      isSingleDate: false,
      isDateRange: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: true,
      IsValid: true,
      IsNoDate: false,
      IsNoTime: false,
      IsNoWeekly: false,
      isDateSelected: true,
      isDateRangeError: false,
      isFromDateRangeError: false,
      isToDateRangeError: false,
      isFromDateRangeGreaterError: false,
    });
  }

  handleMonthlyRecurDate() {
    this.setState({ IsdisableMonthly1: false, IsdisableMonthly3: true });
  }

  handleMonthlyRecurMonth() {
    this.setState({ IsdisableMonthly1: true, IsdisableMonthly3: true });
  }

  handleMonthlyRecurPeriod() {
    this.setState({ IsdisableMonthly1: true, IsdisableMonthly3: false });
  }

  handleYearlyRecurDate() {
    this.setState({ IsdisableYearly1: false, IsdisableYearly3: true });
  }

  handleYearlyRecurMonth() {
    this.setState({ IsdisableYearly1: true, IsdisableYearly3: true });
  }

  handleYearlyRecurPeriod() {
    this.setState({ IsdisableYearly1: true, IsdisableYearly3: false });
  }

  handleExcelChange() {
    if (this.refs.SchCkExcel.checked) {
      this.setState({ IsDisableExcelRdButton: false });
    } else {
      if (this.refs.SchCkPDF.checked === false) {
        this.refs.SchCkPDF.checked = true;
      }
      this.setState({ IsDisableExcelRdButton: true });
    }
  }

  handlerdReuseExcelChange() {
    this.setState({
      createFileAlways: false,
      isFileCreated: true,
    });
  }

  handlerdNewExcelChange() {
    this.setState({
      createFileAlways: true,
      isFileCreated: false,
    });
  }

  handlePDFChange() {
    if (
      this.refs.SchCkPDF.checked === false &&
      this.refs.SchCkExcel.checked === false
    ) {
      this.refs.SchCkExcel.checked = true;
    }
  }

  onChangeValue = (event) => {
    this.setState({ value: event.target.value });
  };

  handleFileFormatExcel(evt) {
    this.setState({ isExcelChecked: true });
  }

  handleFileFormatCSV(evt) {
    this.setState({ isExcelChecked: false });
  }

  excelFileOption(createFileAlways, isFileCreated) {
    this.setState({
      createFileAlways: createFileAlways,
      isFileCreated: isFileCreated,
    });
  }

  editReportWeekly = (id) => {
    if (id) {
      // set the state for the days of the week selected
      this.setState({
        Sunday: id.includes(0) ? true : false,
        Monday: id.includes(1) ? true : false,
        Tuesday: id.includes(2) ? true : false,
        Wednesday: id.includes(3) ? true : false,
        Thursday: id.includes(4) ? true : false,
        Friday: id.includes(5) ? true : false,
        Saturday: id.includes(6) ? true : false,
      });
    }
  };

  onAddItem = () => {
    var ReportFormat = "",
      CreateFileAlways = false,
      IsFileCreated = false;
    let CreateExcel = false,
      CreatePDF = false,
      CreateCSV = false;
    this.setState({ IsNoWeekly: false, isDateSelected: true });
    let isThereAnError = false;

    var TimeRec = this.state.startTimeRec;
    var hasNoTime = TimeRec === undefined || TimeRec === null || TimeRec.length === 0;
    this.setState({IsNoTime: hasNoTime});

    if (this.state.IsFromReportSchedules === false) {
      if (this.refs.ExportCSV.checked === true) {
        ReportFormat = "CSV"; //CSV
        CreateCSV = true;
      }
      if (this.refs.ExportExcel.checked === true) {
        ReportFormat = "Excel"; //Excel
        CreateExcel = true;
      }
    } else {
      if (this.state.reportType !== 99) {
        if (this.refs.SchCkPDF.checked === true) {
          ReportFormat = "PDF"; // PDF
          CreatePDF = true;
        }
        if (this.refs.SchCkExcel.checked) {
          ReportFormat = "Excel"; // Excel
          CreateExcel = true;
          if (this.state.createFileAlways) {
            CreateFileAlways = true;
            IsFileCreated = false;
            this.excelFileOption(true, false);
            ReportFormat = "Excel - Create a new Excel file";
          } else {
            CreateFileAlways = false;
            IsFileCreated = true;
            this.excelFileOption(false, true);
            ReportFormat = "Excel - Reuse the same Excel file";
          }
        }
        if (
          this.refs.SchCkPDF.checked === true &&
          this.refs.SchCkExcel.checked === true
        ) {
          ReportFormat = "PDF and Excel"; // PDF and Excel
          CreatePDF = true;
          CreateExcel = true;
          if (this.state.createFileAlways) {
            CreateFileAlways = true;
            IsFileCreated = false;
            this.excelFileOption(true, false);
            ReportFormat = "PDF and Excel - Create a new Excel file";
          } else {
            CreateFileAlways = false;
            IsFileCreated = true;
            this.excelFileOption(false, true);
            ReportFormat = "PDF and Excel - Reuse the same Excel file";
          }
        }
      } else {
        if (this.refs.ExportCSV.checked === true) {
          ReportFormat = "CSV"; //CSV
          CreateCSV = true;
        }
        if (this.refs.ExportExcel.checked === true) {
          ReportFormat = "Excel"; //Excel
          CreateExcel = true;
        }
      }
    }

    var FormatedTime;
    var Current = new Date();
    Current.setHours(0, 0, 0, 0);

    let IsValid1 = true;


    if (this.props.UserPreference_response !== undefined && !hasNoTime) {
      if (
        this.props.UserPreference_response.timeFormatText !== "Time24HourFormat"
      ) {
        FormatedTime = moment(TimeRec).format("h:mm A");
      } else {
        FormatedTime = moment(TimeRec).format("HH:mm");
      }
    }

    var index_Array = this.state.ExportRecurrenceList.map((el) =>
      parseInt(el.id)
    );

    var maxid =
      this.state.ExportRecurrenceList.length === 0
        ? 0
        : Math.max(...index_Array);

    // Single Date
    if (this.state.isSingleDate) {
      var DateRec;
      if (this.state.startDateRec !== null) DateRec = this.state.startDateRec;

      var GivenMoment = moment(TimeRec);
      var CurrentMoment = moment();


      if (DateRec === undefined) {
        this.setState({ IsValid: false });
        this.setState({ IsNoDate: true });
        IsValid1 = false;
      } else if (DateRec.getTime() < Current.getTime()) {
        this.setState({ IsValid: false });
        this.setState({ IsNoDate: false });
        IsValid1 = false;
      } else {
        if (
          DateRec.getTime() === Current.getTime() &&
          GivenMoment.valueOf() < CurrentMoment.valueOf()
        ) {
          this.setState({ IsValid: false });
          this.setState({ IsNoDate: false });
          IsValid1 = false;
        } else {
          this.setState({ IsValid: true });
          this.setState({ IsNoDate: false });
          IsValid1 = !hasNoTime; 

          if (IsValid1) {
          this.setState({
            EffectiveDaysString: this.state.startDateRec + " at ",
          });
          let EffectiveDays =
            month[this.state.startDateRec.getMonth()] +
            " " +
            this.state.startDateRec.getDate() +
            " , " +
            this.state.startDateRec.getFullYear() +
            " at " +
            " " +
            FormatedTime;

          // i don't know why this is necessary to concat the old date with the new array entry..
          // we need to stop concatenating the date reange dates into the calender entries.
          var TempcalendarEntries = {
            day: 0,
            sun: 0,
            mon: 0,
            tue: 0,
            wed: 0,
            thu: 0,
            fri: 0,
            sat: 0,
            hour: TimeRec ? TimeRec.hour() : '',
            interval: "P1D",
            isExclusion: false,
            isStartDateTime: false,
            key: null,
            minute: TimeRec ? TimeRec.minute() : '',
            modifier: 0,
            month: 0,
            offset: null,
            range: {
              from: DateRec.toLocaleString(),
              timeSpan: "23:59:00",
              to: DateRec.toLocaleString(),
            },
            reportCalendarId: 0,
            reportId: this.state.reportId,
            reportScheduleId: 0,
          };

          this.setState({ calendarEntries: TempcalendarEntries });

          var TempList = this.state.ExportRecurrenceList.concat({
            id: maxid + 1,
            EffectiveDaysString: EffectiveDays,
            artifactId: 0,
            createExcel: CreateExcel,
            createFileAlways: CreateFileAlways,
            createPDF: CreatePDF,
            createCSV: CreateCSV,
            calendarEntries: TempcalendarEntries,
            day: null,
            daysOfWeek: [],
            exportFormat: ReportFormat,
            hour: TimeRec ? TimeRec.hour() : null,
            interval: "P1D",
            isFileCreated: IsFileCreated,
            key: null,
            minute: TimeRec ? TimeRec.minute() : null,
            modifier: null,
            month: null,
            nextSchedule: "0001-01-01T00:00:00",
            reportId: this.state.reportId,
            reportScheduleId: 0,
            reportScheduleMappingId: 0,
          });
          var AmpList = this.state.AmplitudeRecurrenceList.concat({
            id: maxid + 1,
            interval: "P1D",
            intervalType: "Single Date",
            reportId: this.state.reportId,
            exportFormat: ReportFormat,
            createExcel: CreateExcel,
            createFileAlways: CreateFileAlways,
            createPDF: CreatePDF,
            createCSV: CreateCSV,
            isFileCreated: IsFileCreated,
          });

          this.setState({ ExportRecurrenceList: TempList });
          this.setState({ AmplitudeRecurrenceList: AmpList });
        }

        }
      }
    }
    //DateRange
    else if (this.state.isDateRange) {
      var FromDate, ToDate, DateRangeMsg;

      FromDate = this.state.fromDateRec && this.state.fromDateRec !== null && this.state.fromDateRec !== "" ? this.state.fromDateRec.toLocaleString() : null;
      ToDate = this.state.toDateRec !== null ? this.state.toDateRec.toLocaleString() : "";

 if (!hasNoTime) {     
      if (FromDate === undefined || FromDate === null || FromDate === "") {
        this.setState({
          isDateRangeError: true,
          isFromDateRangeError: true,
          isToDateRangeError: false,
          IsNoDate: false
        });
        IsValid1 = false;
        isThereAnError = true;
      } else if (
        new Date(FromDate).getTime() > new Date(ToDate).getTime() ||
        new Date(FromDate).getTime() === new Date(ToDate).getTime() ||
        new Date(ToDate).getTime() < new Date().getTime()
      ) {
        this.setState({
          isDateRangeError: true,
          isFromDateRangeError: false,
          isToDateRangeError: true,
        });
        IsValid1 = false;
        isThereAnError = true;
        console.log(
          "Setting dates to false because from date time is greater then to date time or equal to todate time"
        );
      } else if (new Date().setHours(0, 0, 0, 0) > new Date(FromDate)) {
        console.log(new Date());
        console.log(new Date(FromDate));
        this.setState({
          isDateRangeError: true,
          isFromDateRangeGreaterError: true,
          isToDateRangeError: false,
        });
        IsValid1 = false;
        isThereAnError = true;
        console.log(
          "Setting dates to false because from date time is greater then current date time"
        );
      } else {
        console.log("saving with an empty todate string");
        console.log(this.state.fromDateRec.toLocaleString());

        this.setState({ IsValid: !hasNoTime });
        this.setState({ IsNoDate: false });
        IsValid1 = !hasNoTime; 
        isThereAnError = hasNoTime;

      if (IsValid1) {

        this.setState({
          EffectiveDaysString:
            this.state.fromDateRec + "," + this.state.toDateRec,
        });

        if (ToDate !== "") {
          DateRangeMsg =
            " to " +
            month[this.state.toDateRec.getMonth()] +
            " " +
            this.state.toDateRec.getDate() +
            " , " +
            this.state.toDateRec.getFullYear();
        } else {
          DateRangeMsg = "";
        }

        let EffectiveDays =
          "Every day from " +
          month[this.state.fromDateRec.getMonth()] +
          " " +
          this.state.fromDateRec.getDate() +
          " , " +
          this.state.fromDateRec.getFullYear() +
          DateRangeMsg +
          " at " +
          FormatedTime;

        var TempcalendarEntries1 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1D",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: FromDate, timeSpan: "23:59:00", to: ToDate },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };

        this.setState({ calendarEntries: TempcalendarEntries1 });

        var TempList1 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: EffectiveDays,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries1,
          day: null,
          daysOfWeek: [],
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1D",
          intervalType: "Date Range",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: null,
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });

        var AmpList1 = this.state.AmplitudeRecurrenceList.concat({
          id: maxid + 1,
          interval: "P1D",
          intervalType: "Date Range",
          reportId: this.state.reportId,
          exportFormat: ReportFormat,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          isFileCreated: IsFileCreated,
        });

        this.setState({ ExportRecurrenceList: TempList1 });
        this.setState({ AmplitudeRecurrenceList: AmpList1 });


      }
      }
    } else {
      isThereAnError = true;
      IsValid1 = false;

      this.setState({
        IsValid: false,
          isDateRangeError: false,
          isFromDateRangeError: FromDate === null
          //IsNoDate: true 
        });
    }

    }
    //Weekly
    else if (this.state.isWeekly) {
      var DaysofWeekText = [],
        DaysofWeek = [];
      if (this.refs.Sunday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Sunday");
        DaysofWeek.push(0);
      }
      if (this.refs.Monday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Monday");
        DaysofWeek.push(1);
      }
      if (this.refs.Tuesday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Tuesday");
        DaysofWeek.push(2);
      }
      if (this.refs.Wednesday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Wednesday");
        DaysofWeek.push(3);
      }
      if (this.refs.Thursday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Thursday");
        DaysofWeek.push(4);
      }
      if (this.refs.Friday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Friday");
        DaysofWeek.push(5);
      }
      if (this.refs.Saturday.checked) {
        DaysofWeekText = DaysofWeekText.concat("Saturday");
        DaysofWeek.push(6);
      }

      var l_DaysOfWeekString = "";
      if (DaysofWeekText.length && !hasNoTime) {
        IsValid1 = true;
        this.setState({ IsValid: true });
        //Join the Array with comma, and replace the " and " instead of ", " between the last two items
        l_DaysOfWeekString = DaysofWeekText.join(", ").replace(
          /, ((?:.(?!, ))+)$/,
          " and $1"
        );
        l_DaysOfWeekString =
          l_DaysOfWeekString + " of every week at " + FormatedTime;

        var TempcalendarEntries2 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1W",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries2 });

        var TempList13 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: l_DaysOfWeekString,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries2,
          day: null,
          daysOfWeek: DaysofWeek,
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1W",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: null,
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        var AmpList2 = this.state.AmplitudeRecurrenceList.concat({
          id: maxid + 1,
          interval: "P1W",
          intervalType: "Weekly",
          reportId: this.state.reportId,
          exportFormat: ReportFormat,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          isFileCreated: IsFileCreated,
        });
        this.setState({ ExportRecurrenceList: TempList13 });
        this.setState({ AmplitudeRecurrenceList: AmpList2 });
      } else {
        IsValid1 = false;
        this.setState({ IsValid: false, IsNoWeekly: DaysofWeek.length === 0 });
      }
    }
    //Monthly
    else if (this.state.isMonthly) {
      this.setState({ IsValid: !hasNoTime });
      IsValid1 = !hasNoTime;
      var DaysofWeekM = [];

if (!hasNoTime) {
      if (this.refs.RecurDate.checked) {
        var MonthlyRecur =
          "Day " +
          this.refs.RecDays.value +
          " of every month " +
          " at " +
          FormatedTime;

        var TempcalendarEntries4 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1M",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries4 });

        var TempList14 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: MonthlyRecur,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries4,
          day: parseInt(this.refs.RecDays.value),
          daysOfWeek: [],
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1M",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: null,
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList14 });
      }
      if (this.refs.RecurMonth.checked) {
        var MonthlyRecur2 = "The last day of every month at " + FormatedTime;

        var TempcalendarEntries5 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1M",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries5 });

        var TempList15 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: MonthlyRecur2,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries5,
          day: null,
          daysOfWeek: [],
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1M",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList15 });
      }
      if (this.refs.RecurPeriod.checked) {
        var MonthlyRecur3 =
          "The " +
          period[this.refs.RecPeriods.value] +
          " " +
          week[this.refs.RecWeekDays.value] +
          " of every month at " +
          FormatedTime;

        var TempcalendarEntries6 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1M",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries6 });

        DaysofWeekM = DaysofWeekM.concat(parseInt(this.refs.RecWeekDays.value));
        var TempList16 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: MonthlyRecur3,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries6,
          day: null,
          daysOfWeek: DaysofWeekM,
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1M",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: parseInt(this.refs.RecPeriods.value),
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList16 });
      }

      var AmpList3 = this.state.AmplitudeRecurrenceList.concat({
        id: maxid + 1,
        interval: "P1M",
        intervalType: "Monthly",
        reportId: this.state.reportId,
        exportFormat: ReportFormat,
        createExcel: CreateExcel,
        createFileAlways: CreateFileAlways,
        createPDF: CreatePDF,
        createCSV: CreateCSV,
        isFileCreated: IsFileCreated,
      });
      this.setState({ AmplitudeRecurrenceList: AmpList3 });
    }

    }
    //Yearly
    else if (this.state.isYearly) {
      this.setState({ IsValid: !hasNoTime });
      IsValid1 = !hasNoTime;

 if (!hasNoTime) { 
      var DaysofWeekY = [];
      if (this.refs.RecurYearlyDate.checked) {
        var Yearly11 =
          "Every year on day " +
          this.refs.RecYearlyDays.value +
          " of " +
          month[this.refs.RecYearlymonths.value - 1] +
          " at " +
          FormatedTime;

        var TempcalendarEntries7 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries7 });

        var TempList18 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: Yearly11,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries7,
          day: parseInt(this.refs.RecYearlyDays.value),
          daysOfWeek: [],
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: null,
          month: parseInt(this.refs.RecYearlymonths.value),
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList18 });
      }
      if (this.refs.RecurYearlyMonth.checked) {
        var Yearly13 = "The last day of every year at " + FormatedTime;

        var TempcalendarEntries9 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };
        this.setState({ calendarEntries: TempcalendarEntries9 });

        var TempList19 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: Yearly13,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries9,
          day: null,
          daysOfWeek: [],
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: null,
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList19 });
      }
      if (this.refs.RecurYearlyPeriod.checked) {
        var Yearly19 =
          "Every year on the " +
          period[this.refs.RecYearlyPeriod.value] +
          " " +
          week[this.refs.RecYearlyWeekDays.value] +
          " of " +
          month[this.refs.RecYearlyMonth11.value - 1] +
          " at " +
          FormatedTime;
        DaysofWeekY = DaysofWeekY.concat(
          parseInt(this.refs.RecYearlyWeekDays.value)
        );

        var TempcalendarEntries10 = {
          day: 0,
          sun: 0,
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isExclusion: false,
          isStartDateTime: false,
          key: null,
          minute: TimeRec.minute(),
          modifier: 0,
          month: 0,
          offset: null,
          range: { from: new Date(), timeSpan: "23:59:00", to: null },
          reportCalendarId: 0,
          reportId: this.state.reportId,
          reportScheduleId: 0,
        };

        this.setState({ calendarEntries: TempcalendarEntries10 });

        var TempList21 = this.state.ExportRecurrenceList.concat({
          id: maxid + 1,
          EffectiveDaysString: Yearly19,
          artifactId: 0,
          createExcel: CreateExcel,
          createFileAlways: CreateFileAlways,
          createPDF: CreatePDF,
          createCSV: CreateCSV,
          calendarEntries: TempcalendarEntries10,
          day: null,
          daysOfWeek: DaysofWeekY,
          exportFormat: ReportFormat,
          hour: TimeRec.hour(),
          interval: "P1Y",
          isFileCreated: IsFileCreated,
          key: null,
          minute: TimeRec.minute(),
          modifier: parseInt(this.refs.RecYearlyPeriod.value),
          month: parseInt(this.refs.RecYearlyMonth11.value),
          nextSchedule: "0001-01-01T00:00:00",
          reportId: this.state.reportId,
          reportScheduleId: 0,
          reportScheduleMappingId: 0,
        });
        this.setState({ ExportRecurrenceList: TempList21 });
      }
      var AmpList4 = this.state.AmplitudeRecurrenceList.concat({
        id: maxid + 1,
        interval: "P1Y",
        intervalType: "Yearly",
        reportId: this.state.reportId,
        exportFormat: ReportFormat,
        createExcel: CreateExcel,
        createFileAlways: CreateFileAlways,
        createPDF: CreatePDF,
        createCSV: CreateCSV,
        isFileCreated: IsFileCreated,
      });
      this.setState({ AmplitudeRecurrenceList: AmpList4 });

    }

    }

    if (IsValid1 !== false) {
      this.setState({ isOpen: false, isAddDisabled: false });
      this.resetData();
    }
    if (this.state.isEdit === true && isThereAnError === false) {
      this.onRemoveItem(this.state.isRemoveID, this.state.isRemoveScheduleID);
      this.setState({ isEdit: false });
      this.resetData();
    }
  };

  onRemoveItem = (id, reportScheduleId) => {
    this.setState((state) => {
      const ExportRecurrenceList = state.ExportRecurrenceList.filter(
        (item) => item.id !== id
      );
      return { ExportRecurrenceList };
    });

    if (
      this.state.AmplitudeRecurrenceList !== undefined &&
      this.state.AmplitudeRecurrenceList.length > 0 &&
      this.state.AmplitudeRecurrenceList.some((item) => id === item.id)
    ) {
      this.setState((state) => {
        const AmplitudeRecurrenceList = state.AmplitudeRecurrenceList.filter(
          (item) => item.id !== id
        );
        return { AmplitudeRecurrenceList };
      });
    }

      
    if (reportScheduleId !== 0) {
      this.setState((state) => {
        const calendarEntries = Array.isArray(state.calendarEntries) ? state.calendarEntries.filter(
          (item) => item.reportScheduleId !== reportScheduleId
        ) : {};
        return { calendarEntries };
      });
      // check to see if the schedule report list coming in is empty if it is no need to create a delete list
         var DeletedReportScheduleId = [];
          DeletedReportScheduleId = this.state.deletedReportScheduleId.concat({
            reportScheduleId: reportScheduleId,
          });
        this.setState({ deletedReportScheduleId: DeletedReportScheduleId });
    }
  };

  setEditTime = (calendarEntries) => {
    let timeMoment = moment();
    timeMoment.set("hour", calendarEntries.hour);
    timeMoment.set("minute", calendarEntries.minute);
    this.setState({ timeRec: timeMoment });
  };

  setYearlyEditTime = (calendarEntries) => {
    let timeMoment = moment();
    timeMoment.set("hour", calendarEntries.hour);
    timeMoment.set("minute", calendarEntries.minute);
    this.setState({
      startTimeRec: timeMoment,
    });
  };

  editCurrentSchedule = (el) => {
    this.setState({ isEdit: true });
    this.setState({ isAddDisabled: true });

    var reportFormat = el.exportFormat ?  el.exportFormat : "CSV" ;
    if (this.refs.ExportCSV !== undefined) {
      this.refs.ExportCSV.checked = reportFormat.indexOf("CSV") >= 0;
      this.refs.ExportExcel.checked = reportFormat.indexOf("Excel") >= 0;
      this.setState({
        isCSVChecked: reportFormat.indexOf("CSV") >= 0,
        isExcelChecked: reportFormat.indexOf("Excel") >= 0,
      })
    }

    if (this.refs.SchCkPDF !== undefined) {
      this.refs.SchCkExcel.checked = el.createExcel;
      this.refs.SchCkPDF.checked = el.createPDF;
      this.setState({ 
          isFileCreated: el.isFileCreated,
          createFileAlways: el.createFileAlways,
          IsDisableExcelRdButton: !el.createExcel,
      });
    }

    switch (el.interval) {
      case "P1D":
        if (
          el.intervalType === "Date Range" ||
          el.EffectiveDaysString.indexOf("Every day from") >= 0
        ) {
          
          let date = new Date();
          let toDate = null;


         const regexTo = /to\s+(.*?)\s+at/;
         const matchTo = regexTo.exec(el.EffectiveDaysString);
         const toDateStr = matchTo ? matchTo[1].replace(/,\s*/, ","): null;
          toDate = matchTo !== null ? new Date(toDateStr) : null;


          if(toDate !== null){
            const regexFrom = /from\s+(.*?)\s+to/;
            const matchFrom = regexFrom.exec(el.EffectiveDaysString);
            const fromDateStr = matchFrom[1].replace(/,\s*/, ",");
             date = new Date(fromDateStr);
          }else{
                     const regexFrom =/from\s+(.*?)\s+at/;
         const matchFrom = regexFrom.exec(el.EffectiveDaysString);
         const fromDateStr = matchFrom[1].replace(/,\s*/, ",");
          date = new Date(fromDateStr);
          }

          
         this.setState({
            isDateRange: true,
            isSingleDate: false,
            fromDateRec: date,
            toDateRec: toDate,
          });
          this.setEditTime(el);
          this.setYearlyEditTime(el);
        } else {
          this.refs.SingleDate.checked = true;
          this.handleSingleDate();
            const regexFrom = /^(.*?)\s+at/;
            const matchFrom = regexFrom.exec(el.EffectiveDaysString);
            const fromDateStr = matchFrom[1].replace(/\s/g, "");
            const date = new Date(fromDateStr);

            this.setState({
              startDateRec: date,
            });
            this.setYearlyEditTime(el);
          
        }
        break;
      case "P1W":
        this.refs.Weekly.checked = true;
        this.handleWeekly();
        this.editReportWeekly(el.daysOfWeek);
        this.setYearlyEditTime(el);
        break;
      case "P1M":
        this.refs.Monthly.checked = true;
        this.handleMonthly();
        this.setYearlyEditTime(el);
        if (el.day !== null) {
          this.setState({ recurrenceDate: true,IsdisableMonthly1: false, IsdisableMonthly3: true, recDay: el.day });
        } else if (
          el.EffectiveDaysString.indexOf("last day of every month") >= 0
        ) {
          this.setState({ isLastDay: true, recurringMonthly: true });
          this.setState({ IsdisableMonthly1: true, IsdisableMonthly3: true });
        } else if (el.daysOfWeek.length > 0) {
          if(this.refs.RecPeriods !== undefined){
            this.refs.RecPeriods.value = el.modifier;
          }
          this.handleMonthlyRecurPeriod();
          this.setState({ recurringPeriod: true ,
            recurrencePeriod: el.modifier.toString(), 
            recurrenceWeekDay: el.daysOfWeek[0].toString(),             
            IsdisableMonthly1: true, 
            IsdisableMonthly3: false,});
        }
        this.setYearlyEditTime(el);
        break;
      case "P1Y":
        this.refs.Yearly.checked = true;
        this.handleYearly();
        if (el.day !== null) { 
            this.setState({ yearlyDateRadio: true, 
              recurringYearlyDays: el.day, 
              recurringYearlyMonths: el.month,
              IsdisableYearly1: false, 
              IsdisableYearly3: true
            });
        } else if (el.EffectiveDaysString.indexOf("last") >= 0) {
          this.handleYearlyRecurMonth();
          this.setState({
            recurringYearlyMonth: true,
            yearlyDateRadio: false, 
            recurringYearlyPeriod: false,
          });
        } else if (el.daysOfWeek.length > 0) {
          this.handleYearlyRecurPeriod();
          this.setState({
            recurringYearlyMonth: true,
            yearlyDateRadio: false, 
            recurringYearlyPeriod: true,
            recurringYearlyMonthly: el.month,
            recurringWeekDays: el.daysOfWeek[0],
            recurringYearlyPeriods: el.modifier,
          });
        }
        this.setYearlyEditTime(el);
        break;
      default:
        break;
    }
  };

  render(UserPreference_response, getLabels) {
    if (this.state.redirectBack) {
      return <Redirect to="/ManageReports/ManageReportsDefinitions" />;
    }
    let hasFullaccess = this.props.userHasFullaccess;
    hasFullaccess =
      hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess
        ? true
        : false;
    let PreferedDateFormat = this.props.UserPreference_response;
    let UserFormat =
      Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);
    let label = this.props.getLabels;
    let Is12HrFormat = true;

    //white background style for time picker
    var timepickerStyle = document.getElementById("RecRunTime");
    if (timepickerStyle !== null)
      timepickerStyle.className = "rc-time-picker-input white-bg";

    if (PreferedDateFormat !== undefined) {
      if (PreferedDateFormat.timeFormatText !== "Time12HourFormat")
        Is12HrFormat = false;
    }

    let RecDays, RecPeriod, RecWeekDays, RecYearlyMonth;

    var Days = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    ];
    RecDays = Days.map((el) => (
      <option id={el} value={el}>
        {el}
      </option>
    ));

    if (label["EnumSetupReportSchedule.ScheduleRoutine.Text"] !== undefined) {
      var Recur =
        label["EnumSetupReportSchedule.ScheduleRoutine.Text"].split(",");
      RecPeriod = Recur.map((el) => (
        <option id={el} value={el}>
          {label["EnumSetupReportSchedule.ScheduleRoutine." + el + ".Text"]}
        </option>
      ));
    }

    if (label["EnumSetupReportSchedule.WeekDays.Text"] !== undefined) {
      var Format = label["EnumSetupReportSchedule.WeekDays.Text"].split(",");
      RecWeekDays = Format.map((el) => (
        <option id={el} value={el}>
          {label["EnumSetupReportSchedule.WeekDays." + el + ".Text"]}
        </option>
      ));
    }

    if (label["EnumSetupReportSchedule.Months.Text"] !== undefined) {
      var RecYearlyMonth1 =
        label["EnumSetupReportSchedule.Months.Text"].split(",");
      RecYearlyMonth = RecYearlyMonth1.map((el) => (
        <option id={el} value={el}>
          {label["EnumSetupReportSchedule.Months." + el + ".Text"]}
        </option>
      ));
    }

    let DDATA;
    if (this.state.ExportRecurrenceList.length > 0) {
      DDATA = this.state.ExportRecurrenceList.map((el, index) => {
        return (
        <tr key={index} style={{ width: "100%", paddingLeft: "2%" }}>
          <td style={{ width: "41%", paddingLeft: "2%" }}>
            {el.EffectiveDaysString}
          </td>
          <td style={{ width: "30%", paddingLeft: "2%" }}>{el.exportFormat ?  el.exportFormat : "CSV"}</td>
          <td style={{ width: "10%" }}>
            <img
              src={RemoveIcon}
              alt={"Remove"}
              style={hasFullaccess ? { width: "18px" } : { display: "none" }}
              className="link_cursor"
              onClick={() => this.onRemoveItem(el.id, el.reportScheduleId)}
            />
          </td>
          <td style={{ width: "10%" }}>
            <EditIcon
              onClick={() => {
                this.ToggleAddButton();
                this.editCurrentSchedule(el);
                this.setState({
                  isRemoveID: el.id,
                  isRemoveScheduleID: el.reportScheduleId,
                  isEdit: true,
                });
                console.log(
                  "SelectedReportDetails",
                  this.props.scheduleRecurrenceDetails
                );
              }}
              aria-label="Edit"
              style={hasFullaccess ? { width: "18px" } : { display: "none" }}
              className="link_cursor"
            />
          </td>
        </tr>)
    });
    } else {
      DDATA = (
        <tr style={{ width: "100%", paddingLeft: "2%" }}>
          <td style={{ width: "90%", paddingLeft: "2%" }}>
            {"No schedule events exist"}
          </td>
        </tr>
      );
    }

    return (
      <div id="ExportRecurrence">
        {/*Header Section*/}
        <FormGroup row>
          <DataExportHeader isFromReportSchedules={this.state.IsFromReportSchedules} reportNameValue={this.state.reportNameValue} label={label}/>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <Label className="dataexportheaderlbl">
              {label["ExportRecurrence.Text"] !== undefined
                ? label["ExportRecurrence.Text"]
                : "Export Recurrence"}
            </Label>
          </Col>
        </FormGroup>
        <hr />
        <div>
          <Button
            className="btn-success btn-md"
            style={hasFullaccess ? {} : { display: "none" }}
            disabled={this.state.isAddDisabled}
            onClick={this.ToggleAddButton}
          >
            {label["ManageStandardReport.btnAddEmailRecipients.Text"] !==
            undefined
              ? label["ManageStandardReport.btnAddEmailRecipients.Text"]
              : "Add"}
          </Button>
          <FormGroup row>
            <Col sm={{ size: 12 }}></Col>
          </FormGroup>
          <div className="table_container" style={{ paddingRight: "15px" }}>
            <div>
              <table
                style={{
                  paddingLeft: "2%",
                  width: "100%",
                  lineHeight: "38px",
                  backgroundColor: "#DBDBDB",
                  color: "#323232",
                  border: "1px solid grey",
                  fontSize: "16px",
                  fontFamily: "lato",
                }}
              >
                <thead>
                  <tr>
                    <td style={{ paddingLeft: "2%", width: "50%" }}>
                      {label["ExportRecurrence.Text"] !== undefined
                        ? label["ExportRecurrence.Text"]
                        : "Export Recurrence"}
                    </td>
                    <td style={{ paddingLeft: "2%", width: "50%" }}>
                      {label["ExportFormat.Text"] !== undefined
                        ? label["ExportFormat.Text"]
                        : "Export Format"}
                    </td>
                  </tr>
                </thead>
              </table>
              <table
                className="Custom_table fixed_layout "
                style={{ border: "1px solid grey", width: "100%" }}
              >
                <tbody style={{ backgroundColor: "#EBEBEB" }}>
                  <Collapse isOpen={this.state.isOpen}>
                    <div
                      style={{
                        lineHeight: "40%",
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    >
                      <div
                        style={{
                          lineHeight: "165%",
                          width: "100%",
                          paddingLeft: "7px",
                          paddingTop: "4px",
                        }}
                      >
                        <Icon
                          name="exclamation triangle"
                          style={
                            this.state.IsValid ||
                            this.state.IsNoDate ||
                            this.state.IsNoWeekly ||
                            this.state.IsNoTime || 
                            this.state.isDateRangeError
                              ? { display: "none" }
                              : {
                                  color: "red",
                                  "padding-right": "14px",
                                  "padding-top": "0px",
                                }
                          }
                        />
                        <Label
                          style={
                            this.state.IsValid ||
                            this.state.IsNoDate ||
                            this.state.IsNoWeekly ||
                            this.state.IsNoTime || 
                            this.state.isDateRangeError
                              ? { display: "none" }
                              : {}
                          }
                          className="workorderheaderlbl"
                        >
                          {label["DataExport.ScheduleError.Text"] !== undefined
                            ? label["DataExport.ScheduleError.Text"]
                            : "Schedule Event was not created because all occurrences are in the past."}
                        </Label>
                        <Icon
                          name="exclamation triangle"
                          style={
                            this.state.IsNoDate || this.state.IsNoTime
                              ? {
                                  color: "red",
                                  "padding-right": "14px",
                                  "padding-top": "0px",
                                }
                              : { display: "none" }
                          }
                        />
                        <Label
                          style={this.state.IsNoDate || this.state.IsNoTime ? {} : { display: "none" }}
                          className="workorderheaderlbl"
                        >
                          {label[
                            "SetUpReportEmail.ParameterMissingValueError.Text"
                          ] !== undefined
                            ? label[
                                "SetUpReportEmail.ParameterMissingValueError.Text"
                              ]
                            : 'Required fields are blank or have invalid values.  Review and correct any fields with "!" next to them.'}
                        </Label>
                        <Icon
                          name="exclamation triangle"
                          style={
                            this.state.IsNoWeekly && !this.state.IsNoTime
                              ? {
                                  color: "red",
                                  "padding-right": "14px",
                                  "padding-top": "0px",
                                }
                              : { display: "none" }
                          }
                        />
                        <Label
                          style={
                            this.state.IsNoWeekly ? {} : { display: "none" }
                          }
                          className="workorderheaderlbl"
                        >
                          {label["Schedules.WeeklySelectionError.Text"] !==
                          undefined
                            ? label["Schedules.WeeklySelectionError.Text"]
                            : "Please select one or more days in the available list."}
                        </Label>
                        {/* Date Range Error */}
                        <Icon
                          name="exclamation triangle"
                          style={
                            !this.state.isDateRangeError
                              ? { display: "none" }
                              : {
                                  color: "red",
                                  "padding-right": "14px",
                                  "padding-top": "0px",
                                }
                          }
                        />
                        <Label
                          style={
                            !this.state.isToDateRangeError
                              ? { display: "none" }
                              : {}
                          }
                          className="workorderheaderlbl"
                        >
                          {label["DataExport.ToDateRangeError.Text"] !==
                          undefined
                            ? label["DataExport.ToDateRangeError.Text"]
                            : "Please verify from and to date values."}
                        </Label>

                        <Label
                          style={
                            !this.state.isFromDateRangeError 
                              ? { display: "none" }
                              : {paddingLeft: "5px"}
                          }
                          className="workorderheaderlbl"
                        >
                          {label["DataExport.FromDateRangeError.Text"] !==
                          undefined
                            ? label["DataExport.FromDateRangeError.Text"]
                            : "Please select a ‘From’ date."}
                        </Label>

                        <Label
                          style={
                            !this.state.isFromDateRangeGreaterError
                              ? { display: "none" }
                              : {}
                          }
                          className="workorderheaderlbl"
                        >
                          {label["DataExport.FromDateRangeGreateError.Text"] !==
                          undefined
                            ? label["DataExport.FromDateRangeGreaterError.Text"]
                            : "‘From’ date is in the past."}
                        </Label>
                      </div>
                      <div style={{ lineHeight: "165%", width: "100%" }}>
                        <table style={{ width: "100%" }}>
                          <tr>
                            <td style={{ width: "70%" }}>
                              <Label
                                style={{
                                  width: "100%",
                                  paddingLeft: "7px",
                                  lineHeight: "32px",
                                  fontSize: "12px",
                                  fontFamily: "lato",
                                  fontWeight: "bold",
                                }}
                                className="workorderheaderlbl"
                              > 
                                {label["DataExport.Recurrence.Text"] !==
                                undefined
                                  ? label["DataExport.Recurrence.Text"]
                                  : "Recurrence"}
                              </Label>
                            </td>
                            <td>
                              <Label
                                style={{
                                  width: "100%",
                                  paddingLeft: "6px",
                                  fontSize: "12px",
                                  fontFamily: "lato",
                                  fontWeight: "bold",
                                }}
                                className="workorderheaderlbl"
                              >
                                {label[
                                  "SetupReportSchedule.lblReportFormat.Text"
                                ] !== undefined
                                  ? label[
                                      "SetupReportSchedule.lblReportFormat.Text"
                                    ]
                                  : "File Format"}
                              </Label>
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "165%", width: "100%" }}>
                            <td style={{ paddingLeft: "1%", width: "80%" }}>
                              <div style={{ height: "180px", width: "93%" }}>
                                <table
                                  style={{
                                    border: "2px solid green",
                                    width: "100%",
                                    height: "90%",
                                  }}
                                >
                                  <tr style={{ width: "100%" }}>
                                    <td
                                      style={{
                                        width: "20%",
                                        border: "2px solid grey",
                                        paddingLeft: "8px",
                                      }}
                                    >
                                      <table style={{ lineHeight: "22px" }}>
                                        <tr>
                                          <input
                                            type="radio"
                                            ref="SingleDate"
                                            defaultChecked="true"
                                            name="rdRecurrence"
                                            value="1"
                                            onChange={this.handleSingleDate}
                                            className="workorderlbl"
                                            checked={this.state.isSingleDate}
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            style={{ paddingLeft: "7px" }}
                                          >
                                            {label[
                                              "EnumSetupReportSchedule.ScheduleFrequency.0.Text"
                                            ] !== undefined
                                              ? label[
                                                  "EnumSetupReportSchedule.ScheduleFrequency.0.Text"
                                                ]
                                              : "Single Date"}
                                          </Label>
                                        </tr>
                                        <tr>
                                          <input
                                            type="radio"
                                            ref="DateRange"
                                            name="rdRecurrence"
                                            value="1"
                                            onChange={() => {
                                              this.handleDateRange();
                                            }}
                                            className="workorderlbl"
                                            checked={this.state.isDateRange}
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            style={{ paddingLeft: "7px" }}
                                          >
                                            {label[
                                              "EnumSetupReportSchedule.ScheduleFrequency.1.Text"
                                            ] !== undefined
                                              ? label[
                                                  "EnumSetupReportSchedule.ScheduleFrequency.1.Text"
                                                ]
                                              : "Date Range"}
                                          </Label>
                                        </tr>
                                        <tr>
                                          <input
                                            type="radio"
                                            ref="Weekly"
                                            name="rdRecurrence"
                                            value="1"
                                            onChange={this.handleWeekly}
                                            className="workorderlbl"
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            style={{ paddingLeft: "7px" }}
                                          >
                                            {label[
                                              "EnumSetupReportSchedule.ScheduleFrequency.2.Text"
                                            ] !== undefined
                                              ? label[
                                                  "EnumSetupReportSchedule.ScheduleFrequency.2.Text"
                                                ]
                                              : "Weekly"}
                                          </Label>
                                        </tr>
                                        <tr>
                                          <input
                                            type="radio"
                                            ref="Monthly"
                                            name="rdRecurrence"
                                            value="1"
                                            onChange={this.handleMonthly}
                                            className="workorderlbl"
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            style={{ paddingLeft: "7px" }}
                                          >
                                            {label[
                                              "EnumSetupReportSchedule.ScheduleFrequency.3.Text"
                                            ] !== undefined
                                              ? label[
                                                  "EnumSetupReportSchedule.ScheduleFrequency.3.Text"
                                                ]
                                              : "Monthly"}
                                          </Label>
                                        </tr>
                                        <tr>
                                          <input
                                            type="radio"
                                            ref="Yearly"
                                            name="rdRecurrence"
                                            value="1"
                                            onChange={this.handleYearly}
                                            className="workorderlbl"
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            style={{ paddingLeft: "7px" }}
                                          >
                                            {label[
                                              "EnumSetupReportSchedule.ScheduleFrequency.4.Text"
                                            ] !== undefined
                                              ? label[
                                                  "EnumSetupReportSchedule.ScheduleFrequency.4.Text"
                                                ]
                                              : "Yearly"}
                                          </Label>
                                        </tr>
                                      </table>
                                    </td>
                                    <td
                                      style={{
                                        width: "50%",
                                        border: "2px solid grey",
                                        paddingLeft: "8px",
                                      }}
                                    >
                                      {/* Single Date */}
                                      {this.state.isSingleDate ? (
                                        <table style={{ lineHeight: "30px" }}>
                                          <tbody>
                                            <tr></tr>
                                            <tr></tr>
                                            <tr>
                                              <td>
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblOccurOn.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblOccurOn.Text"
                                                      ]
                                                    : "Occur on"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr></tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <label
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <DatePicker
                                                    id="ExpStartDate"
                                                    selected={
                                                      this.state.startDateRec
                                                    }
                                                    minDate={
                                                      this.state.ServerTime
                                                    }
                                                    onChange={
                                                      this.handleChangeRec
                                                    }
                                                    dateFormat={UserFormat}
                                                    utcOffset={0}
                                                    showDisabledMonthNavigation
                                                    value={
                                                      this.state.startDateRec
                                                    }
                                                    className={
                                                      !this.state.IsValid
                                                        ? "errorhighlight workorderedit-dropdown Pm_Full_Width"
                                                        : "workorderedit-dropdown Pm_Full_Width"
                                                    }
                                                  />
                                                  <img
                                                    src={CalendarGif}
                                                    alt="Trane Logo"
                                                    className="link_cursor"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  />
                                                </label>
                                                
                                                <p
                                                  style={{
                                                    paddingTop: "4%",
                                                    float: "right",
                                                  }}
                                                >
                                                  <Icon
                                                    name="exclamation triangle"
                                                    style={
                                                      this.state.IsValid
                                                        ? { display: "none" }
                                                        : {
                                                            color: "red",
                                                            "padding-left":
                                                              "8px",
                                                            "padding-right":
                                                              "14px",
                                                            "padding-top":
                                                              "0px",
                                                          }
                                                    }
                                                  />
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {/* Date Range */}
                                      {this.state.isDateRange ? (
                                        <table
                                          style={{
                                            lineHeight: "23px",
                                            width: "100%",
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblRecurDailyOn.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblRecurDailyOn.Text"
                                                      ]
                                                    : "Recur each day between"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr></tr>
                                            <tr>
                                              <td>
                                                <FormGroup row>
                                                  <Label
                                                    style={{
                                                      fontWeight: "normal",
                                                      marginRight: "2%",
                                                      paddingLeft: "6%",
                                                    }}
                                                    className="workorderlbl"
                                                  >
                                                    {label[
                                                      "SetupReportSchedule.lblFrom.Text"
                                                    ] !== undefined
                                                      ? label[
                                                          "SetupReportSchedule.lblFrom.Text"
                                                        ]
                                                      : "From"}
                                                  </Label>
                                                  <label
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      id="RecFromDate"
                                                      selected={
                                                        this.state.fromDateRec
                                                      }
                                                      minDate={
                                                        this.state.ServerTime
                                                      }
                                                      onChange={
                                                        this.FromDateChangeRec
                                                      }
                                                      dateFormat={UserFormat}
                                                      utcOffset={0}
                                                      showDisabledMonthNavigation
                                                      value={
                                                        this.state.fromDateRec
                                                      }
                                                      className={
                                                        this.state
                                                          .isFromDateRangeError ||
                                                        this.state
                                                          .isFromDateRangeGreaterError
                                                          ? "errorhighlight workorderedit-dropdown Pm_Full_Width"
                                                          : "workorderedit-dropdown Pm_Full_Width"
                                                      }
                                                    />
                                                    <img
                                                      src={CalendarGif}
                                                      alt="Trane Logo"
                                                      className="link_cursor"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    />
                                                  </label>
                                                  <Icon
                                                    name="exclamation triangle"
                                                    style={
                                                      this.state
                                                        .isFromDateRangeError ||
                                                      this.state
                                                        .isFromDateRangeGreaterError
                                                        ? {
                                                            color: "red",
                                                            "padding-left":
                                                              "8px",
                                                            "padding-right":
                                                              "14px",
                                                            "padding-top":
                                                              "4px",
                                                          }
                                                        : { display: "none" }
                                                    }
                                                  />
                                                </FormGroup>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <FormGroup row>
                                                  <Label
                                                    style={{
                                                      fontWeight: "normal",
                                                      marginRight: "6%",
                                                      paddingLeft: "7%",
                                                    }}
                                                    className="workorderlbl"
                                                  >
                                                    {label[
                                                      "SetupReportSchedule.lblTo.Text"
                                                    ] !== undefined
                                                      ? label[
                                                          "SetupReportSchedule.lblTo.Text"
                                                        ]
                                                      : "To"}
                                                  </Label>
                                                  <label
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      id="RecToDate"
                                                      selected={
                                                        this.state.toDateRec
                                                      }
                                                      minDate={
                                                        this.state.ServerTime
                                                      }
                                                      onChange={
                                                        this.ToDateChangeRec
                                                      }
                                                      dateFormat={UserFormat}
                                                      utcOffset={0}
                                                      showDisabledMonthNavigation
                                                      value={
                                                        this.state.toDateRec
                                                      }
                                                      className={
                                                        this.state
                                                          .isToDateRangeError
                                                          ? "errorhighlight workorderedit-dropdown Pm_Full_Width"
                                                          : "workorderedit-dropdown Pm_Full_Width"
                                                      }
                                                    />
                                                    <img
                                                      src={CalendarGif}
                                                      alt="Trane Logo"
                                                      className="link_cursor"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    />
                                                  </label>
                                                  <Icon
                                                    name="exclamation triangle"
                                                    style={
                                                      this.state
                                                        .isToDateRangeError
                                                        ? {
                                                            color: "red",
                                                            "padding-left":
                                                              "8px",
                                                            "padding-right":
                                                              "14px",
                                                            "padding-top":
                                                              "4px",
                                                          }
                                                        : { display: "none" }
                                                    }
                                                  />
                                                  <Icon
                                                    name="exclamation triangle"
                                                    style={
                                                      this.state.IsNoDate ===
                                                        true &&
                                                      this.state.IsValid ===
                                                        true
                                                        ? {
                                                            color: "red",
                                                            "padding-left":
                                                              "8px",
                                                            "padding-right":
                                                              "14px",
                                                            "padding-top":
                                                              "4px",
                                                          }
                                                        : { display: "none" }
                                                    }
                                                  />
                                                </FormGroup>
                                              </td>
                                            </tr>
                                            <tr></tr>
                                            <tr></tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {/* Weekly */}
                                      {this.state.isWeekly ? (
                                        <table
                                          style={{
                                            lineHeight: "21px",
                                            width: "100%",
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblRecurEveryWeek.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblRecurEveryWeek.Text"
                                                      ]
                                                    : "Recur every week on"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  ref="Sunday"
                                                  name="rdRequestType"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={this.state.Sunday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Sunday:
                                                        !this.state.Sunday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{ marginRight: "17%" }}
                                                >
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.0.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.0.Text"
                                                      ]
                                                    : "Sunday"}
                                                </Label>
                                                <input
                                                  type="checkbox"
                                                  ref="Thursday"
                                                  name="rdRequestType"
                                                  value="5"
                                                  className="workorderlbl"
                                                  checked={this.state.Thursday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Thursday:
                                                        !this.state.Thursday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.4.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.4.Text"
                                                      ]
                                                    : "Thursday"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  ref="Monday"
                                                  name="rdRequestType"
                                                  value="2"
                                                  className="workorderlbl"
                                                  checked={this.state.Monday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Monday:
                                                        !this.state.Monday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{ marginRight: "16%" }}
                                                >
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.1.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.1.Text"
                                                      ]
                                                    : "Monday"}
                                                </Label>
                                                <input
                                                  type="checkbox"
                                                  ref="Friday"
                                                  name="rdRequestType"
                                                  value="6"
                                                  className="workorderlbl"
                                                  checked={this.state.Friday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Friday:
                                                        !this.state.Friday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.5.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.5.Text"
                                                      ]
                                                    : "Friday"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  ref="Tuesday"
                                                  name="rdRequestType"
                                                  value="3"
                                                  className="workorderlbl"
                                                  checked={this.state.Tuesday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Tuesday:
                                                        !this.state.Tuesday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{ marginRight: "16%" }}
                                                >
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.2.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.2.Text"
                                                      ]
                                                    : "Tuesday"}
                                                </Label>
                                                <input
                                                  type="checkbox"
                                                  ref="Saturday"
                                                  name="rdRequestType"
                                                  value="7"
                                                  className="workorderlbl"
                                                  checked={this.state.Saturday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Saturday:
                                                        !this.state.Saturday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.6.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.6.Text"
                                                      ]
                                                    : "Saturday"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  ref="Wednesday"
                                                  name="rdRequestType"
                                                  value="4"
                                                  className="workorderlbl"
                                                  checked={this.state.Wednesday}
                                                  onChange={() => {
                                                    this.setState({
                                                      Wednesday:
                                                        !this.state.Wednesday,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{ marginRight: "16%" }}
                                                >
                                                  {label[
                                                    "EnumSetupReportSchedule.WeekDays.3.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "EnumSetupReportSchedule.WeekDays.3.Text"
                                                      ]
                                                    : "Wednesday"}
                                                </Label>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {/* Monthly */}
                                      {this.state.isMonthly ? (
                                        <table
                                          style={{
                                            lineHeight: "26px",
                                            width: "100%",
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblRecurEveryMonth.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblRecurEveryMonth.Text"
                                                      ]
                                                    : "Recur every month on"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurDate"
                                                  defaultChecked="true"
                                                  name="rdMonthly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state.recurrenceDate
                                                  }
                                                  onChange={() => {
                                                    this.handleMonthlyRecurDate();
                                                    this.setState({
                                                      recurrenceDate:
                                                        !this.state
                                                          .recurrenceDate,
                                                      recurringMonthly: false,
                                                      recurringPeriod: false,
                                                    });
                                                  }}
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "DataExport.Date.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "DataExport.Date.Text"
                                                      ]
                                                    : "Date"}
                                                </Label>
                                                <select
                                                  ref="RecDays"
                                                  disabled={
                                                    this.state.IsdisableMonthly1
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableMonthly1
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recDay:
                                                        event.target.value,
                                                    });
                                                  }}
                                                  value={this.state.recDay}
                                                >
                                                  {RecDays}
                                                </select>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurMonth"
                                                  onChange={() => {
                                                    this.handleMonthlyRecurMonth();
                                                    this.setState({
                                                      recurringMonthly:
                                                        !this.state
                                                          .recurringMonthly,
                                                      recurringPeriod: false,
                                                      recurrenceDate: false,
                                                    });
                                                  }}
                                                  name="rdMonthly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state.recurringMonthly
                                                  }
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "DataExport.Schedule.LastDayMonth.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "DataExport.Schedule.LastDayMonth.Text"
                                                      ]
                                                    : "Last day of the month"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurPeriod"
                                                  onChange={() => {
                                                    this.handleMonthlyRecurPeriod();
                                                    this.setState({
                                                      recurringPeriod:
                                                        !this.state
                                                          .recuringPeriod,
                                                      recurringMonthly: false,
                                                      recurrenceDate: false,
                                                    });
                                                  }}
                                                  name="rdMonthly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state.recurringPeriod
                                                  }
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblThe.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblThe.Text"
                                                      ]
                                                    : "The"}
                                                </Label>
                                                <select
                                                  ref="RecPeriods"
                                                  disabled={
                                                    this.state.IsdisableMonthly3
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableMonthly3
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurrencePeriod:
                                                        event.target.value,
                                                    });
                                                  }}
                                                  value={
                                                    this.state.recurrencePeriod
                                                  }
                                                >
                                                  {RecPeriod}
                                                </select>
                                                <select
                                                  ref="RecWeekDays"
                                                  disabled={
                                                    this.state.IsdisableMonthly3
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableMonthly3
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  value={
                                                    this.state.recurrenceWeekDay
                                                  }
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurrenceWeekDay:
                                                        event.target.value,
                                                    });
                                                  }}
                                                >
                                                  {RecWeekDays}
                                                </select>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {/* Yearly */}
                                      {this.state.isYearly ? (
                                        <table
                                          style={{
                                            lineHeight: "26px",
                                            width: "100%",
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblRecurEveryYear.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblRecurEveryYear.Text"
                                                      ]
                                                    : "Recur every year on"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurYearlyDate"
                                                  onChange={() => {
                                                    this.handleYearlyRecurDate();
                                                    this.setState({
                                                      yearlyDateRadio: true,
                                                      recurringYearlyMonth: false,
                                                      recurringYearlyPeriod: false,
                                                    });
                                                  }}
                                                  name="rdYearly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state.yearlyDateRadio
                                                  }
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "DataExport.Date.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "DataExport.Date.Text"
                                                      ]
                                                    : "Date"}
                                                </Label>
                                                <select
                                                  ref="RecYearlyDays"
                                                  disabled={
                                                    this.state.IsdisableYearly1
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableYearly1
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  value={
                                                    this.state
                                                      .recurringYearlyDays
                                                  }
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurringYearlyDays:
                                                        event.target.value,
                                                    });
                                                  }}
                                                >
                                                  {RecDays}
                                                </select>
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{
                                                    paddingLeft: "1%",
                                                    paddingRight: "1%",
                                                  }}
                                                >
                                                  {label[
                                                    "SetupReportSchedule.lblOf.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblOf.Text"
                                                      ]
                                                    : "of"}
                                                </Label>
                                                <select
                                                  ref="RecYearlymonths"
                                                  disabled={
                                                    this.state.IsdisableYearly1
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableYearly1
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  value={
                                                    this.state
                                                      .recurringYearlyMonths
                                                  }
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurringYearlyMonths:
                                                        event.target.value,
                                                    });
                                                  }}
                                                >
                                                  {RecYearlyMonth}
                                                </select>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurYearlyMonth"
                                                  onChange={() => {
                                                    this.handleYearlyRecurMonth();

                                                    this.setState({
                                                      yearlyDateRadio: false,
                                                      recurringYearlyMonth:
                                                        !this.state
                                                          .recurringYearlyMonth,
                                                      recurringYearlyPeriod: false,
                                                    });
                                                  }}
                                                  name="rdYearly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state
                                                      .recurringYearlyMonth
                                                  }
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblLastDayOfYear.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblLastDayOfYear.Text"
                                                      ]
                                                    : "Last day of year"}
                                                </Label>
                                              </td>
                                            </tr>
                                            <tr style={{ paddingLeft: "4%" }}>
                                              <td>
                                                <input
                                                  type="radio"
                                                  ref="RecurYearlyPeriod"
                                                  onChange={() => {
                                                    this.handleYearlyRecurPeriod();
                                                    this.setState({
                                                      yearlyDateRadio: false,
                                                      recurringYearlyPeriod:
                                                        !this.state
                                                          .recurringYearlyPeriod,
                                                      recurringYearlyMonth: false,
                                                    });
                                                  }}
                                                  name="rdYearly"
                                                  value="1"
                                                  className="workorderlbl"
                                                  checked={
                                                    this.state
                                                      .recurringYearlyPeriod
                                                  }
                                                />
                                                {"     "}
                                                <Label className="workorderheaderlbl">
                                                  {label[
                                                    "SetupReportSchedule.lblThe.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblThe.Text"
                                                      ]
                                                    : "The"}
                                                </Label>
                                                <select
                                                  ref="RecYearlyPeriod"
                                                  disabled={
                                                    this.state.IsdisableYearly3
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableYearly3
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurringYearlyPeriods:
                                                        event.target.value,
                                                    });
                                                  }}
                                                  value={
                                                    this.state
                                                      .recurringYearlyPeriods
                                                  }
                                                >
                                                  {RecPeriod}
                                                </select>
                                                <select
                                                  ref="RecYearlyWeekDays"
                                                  disabled={
                                                    this.state.IsdisableYearly3
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableYearly3
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurringWeekDays:
                                                        event.target.value,
                                                    });
                                                  }}
                                                  value={
                                                    this.state.recurringWeekDays
                                                  }
                                                >
                                                  {RecWeekDays}
                                                </select>
                                                <Label
                                                  className="workorderheaderlbl"
                                                  style={{
                                                    paddingLeft: "1%",
                                                    paddingRight: "1%",
                                                  }}
                                                >
                                                  {label[
                                                    "SetupReportSchedule.lblOf.Text"
                                                  ] !== undefined
                                                    ? label[
                                                        "SetupReportSchedule.lblOf.Text"
                                                      ]
                                                    : "of"}
                                                </Label>
                                                <select
                                                  ref="RecYearlyMonth11"
                                                  disabled={
                                                    this.state.IsdisableYearly3
                                                  }
                                                  className={
                                                    "minimal workorderedit-dropdown"
                                                  }
                                                  style={{
                                                    color: "gray",
                                                    marginLeft: "1%",
                                                    backgroundColor: this.state
                                                      .IsdisableYearly3
                                                      ? "#F4F4F4"
                                                      : "#FFFFFF",
                                                  }}
                                                  onChange={(event) => {
                                                    this.setState({
                                                      recurringYearlyMonthly:
                                                        event.target.value,
                                                    });
                                                  }}
                                                  value={
                                                    this.state
                                                      .recurringYearlyMonthly
                                                  }
                                                >
                                                  {RecYearlyMonth}
                                                </select>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </td>
                            <td style={{ width: "20%" }}>
                              <div style={{ height: "150px" }}>
                                {this.state.IsFromReportSchedules &&
                                this.state.reportType !== 99 ? (
                                  <table style={{ width: "100%" }}>
                                    <tr>
                                      <td>
                                        {" "}
                                        {this.state.reportType === -1 ? (
                                          <input
                                            type="checkbox"
                                            ref="SchCkPDF"
                                            name="SchCkPDF"
                                            onChange={this.handlePDFChange}
                                            defaultChecked={true}
                                            value="1"
                                            className="workorderlbl"
                                          />
                                        ) : (
                                          <input
                                            type="checkbox"
                                            ref="SchCkPDF"
                                            name="SchCkPDF"
                                            checked={true}
                                            defaultChecked={true}
                                            value="1"
                                            className="workorderlbl"
                                          />
                                        )}
                                        <Label
                                          className="workorderheaderlbl"
                                          style={{
                                            display: "inline",
                                            paddingLeft: "8px",
                                          }}
                                        >
                                          PDF
                                        </Label>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        display:
                                          this.state.reportType === -1
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          ref="SchCkExcel"
                                          name="SchCkExcel"
                                          value="1"
                                          onChange={this.handleExcelChange}
                                          className="workorderlbl"
                                        />
                                        <Label
                                          className="workorderheaderlbl"
                                          style={{
                                            display: "inline",
                                            paddingLeft: "8px",
                                          }}
                                        >
                                          Excel
                                        </Label>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        display:
                                          this.state.reportType === -1
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <td style={{ paddingLeft: "18px" }}>
                                        <input
                                          type="radio"
                                          ref="rdNewExcel"
                                          disabled={
                                            this.state.IsDisableExcelRdButton
                                          }
                                          onChange={this.handlerdNewExcelChange}
                                          name="rdNewExcel"
                                          defaultChecked={true}
                                          className="workorderlbl"
                                          checked={this.state.createFileAlways}
                                        />
                                        <Label
                                          className="workorderheaderlbl"
                                          disabled={
                                            this.state.IsDisableExcelRdButton
                                          }
                                          style={{
                                            display: "inline",
                                            paddingLeft: "8px",
                                          }}
                                        >
                                          Create a new Excel file each time the
                                          report is run.
                                        </Label>
                                      </td>
                                    </tr>
                                    {this.state.isSingleDate === false && (
                                      <tr
                                        style={{
                                          display:
                                            this.state.reportType === -1
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <td style={{ paddingLeft: "18px" }}>
                                          <input
                                            type="radio"
                                            ref="rdReuseExcel"
                                            disabled={
                                              this.state.IsDisableExcelRdButton
                                            }
                                            onChange={
                                              this.handlerdReuseExcelChange
                                            }
                                            name="rdNewExcel"
                                            className="workorderlbl"
                                            checked={this.state.isFileCreated}
                                          />
                                          <Label
                                            className="workorderheaderlbl"
                                            disabled={
                                              this.state.IsDisableExcelRdButton
                                            }
                                            style={{
                                              display: "inline",
                                              paddingLeft: "8px",
                                            }}
                                          >
                                            Reuse the same Excel file whenever
                                            the report is run, appending a new
                                            worksheet each time.
                                          </Label>
                                        </td>
                                      </tr>
                                    )}
                                  </table>
                                ) : (
                                  <table style={{ width: "100%" }}>
                                    <tr>
                                      <td>
                                        <input
                                          type="checkbox"
                                          ref="ExportExcel"
                                          checked={
                                            this.state.isExcelChecked
                                          }
                                          onChange={(evt) =>{
                                            this.setState({
                                              isExcelChecked:
                                                !this.state.isExcelChecked,
                                              isCSVChecked:
                                                !this.state.isCSVChecked,
                                            });
                                          }
                                          }
                                          name="ExpCkExcel"
                                          className="workorderlbl"
                                        />
                                        <Label
                                          className="workorderheaderlbl"
                                          style={{
                                            display: "inline",
                                            paddingLeft: "8px",
                                          }}
                                        >
                                          Excel
                                        </Label>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <input
                                          type="checkbox"
                                          ref="ExportCSV"
                                          checked={
                                            this.state.isCSVChecked
                                          }
                                          onChange={(evt) => {
                                            this.setState({
                                              isExcelChecked:
                                                !this.state.isExcelChecked,
                                              isCSVChecked:
                                                !this.state.isCSVChecked,
                                            });
                                          }}
                                          name="ExpCkCSV"
                                          className="workorderlbl"
                                        />
                                        <Label
                                          className="workorderheaderlbl"
                                          style={{
                                            display: "inline",
                                            paddingLeft: "8px",
                                          }}
                                        >
                                          CSV
                                        </Label>
                                      </td>
                                    </tr>
                                  </table>
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "200%", width: "100%" }}>
                            <td>
                              <Label
                                className="dataexportheaderlbl"
                                style={{ paddingLeft: "6px" }}
                              >
                                {label["DataExport.RunTime.Text"] !== undefined
                                  ? label["DataExport.RunTime.Text"]
                                  : "Run Time"}
                              </Label>
                            </td>
                          </tr>
                          
                          <tr style={{ lineHeight: "1.5em", width: "100%" }}>
                            <td colSpan="2">
                              <label
                                style={
                                  this.state.disablecustomRadio
                                    ? {
                                        cursor: "pointer",
                                        pointerEvents: "none",
                                        paddingLeft: "6px",
                                      }
                                    : { cursor: "pointer", paddingLeft: "6px" }
                                }
                              >
                                <TimePicker
                                  ref="Time_in_timepickerRec"
                                  id="RecRunTime"
                                  placeholder="Select Time"
                                  onChange={this.handleValueChangeRec}
                                  use12Hours={Is12HrFormat}
                                  format={Is12HrFormat ? "h:mm A" : "HH:mm"}
                                  value={this.state.startTimeRec}
                                  showSecond={false}
                                  open={this.state.openRec}
                                  onOpen={this.setOpenRec}
                                  onClose={this.setCloseRec}
                                  style={{ width: "100%", height:"24px" }}
                                  focusOnOpen
                                />
                                <div
                                  className="pm_timerdiv"
                                  style={{ marginTop: "-12%"}}
                                >
                                  <FaClock
                                    className="pm_calendarbox"
                                    width="17px"
                                    height="17px"
                                  />
                                </div>
                              </label>
                              <Icon
                          name="exclamation triangle"
                          style={
                            !this.state.IsNoTime
                              ? { display: "none" }
                              : {
                                  color: "red",
                                  "padding-left": "5px",
                                  "padding-top": "0px",
                                }
                          }
                        /> 
                              <Label id="recommentationLbl" style={{paddingLeft:"5px", lineHeight: "1.5em"}}>
                                {label["DataExport.Recommendation.Text"] !== undefined
                                  ? label["DataExport.Recommendation.Text"]
                                  : "Tip: avoid scheduling multiple reports with the same run time"}
                              </Label>

                            </td>
                            <td />
                          </tr>
                        </table>
                      </div>
                      <div
                        style={{
                          display: "inline",
                          backgroundColor: "#EBEBEB",
                          lineHeight: "40px",
                          width: "100%",
                        }}
                      >
                        <Button
                          style={{
                            float: "right",
                            marginLeft: "0px",
                            marginBottom: "9px",
                            marginTop: "9px",
                          }}
                          onClick={() => {
                            this.onAddItem();
                          }}
                          className="btn-success btn-md"
                        >
                          {label["Buttons.Save.Text"] !== undefined
                            ? label["Buttons.Save.Text"]
                            : "Save"}
                        </Button>
                        <Button
                          style={{
                            float: "right",
                            marginLeft: "0px",
                            marginBottom: "9px",
                            marginTop: "9px",
                          }}
                          className="btn-gray btn-md"
                          onClick={this.ToggleCancelButton}
                        >
                          {label["Buttons.Cancel.Text"] !== undefined
                            ? label["Buttons.Cancel.Text"]
                            : "Cancel"}
                        </Button>
                      </div>
                    </div>
                  </Collapse>
                </tbody>
              </table>
            </div>
            <div style={{ overflowY: "auto", height: "200px" }}>
              <table className="Custom_table fixed_layout table table-striped">
                <tbody className="cell_container">{DDATA}</tbody>
              </table>
            </div>
          </div>
        </div>

        {/*Button*/}
        <FormGroup
          row
          className={this.state.isAddDisabled ? "" : "report_buttons"}
        >
          <Col sm={{ size: 12 }}>
            <hr />
            <Label
              style={{ position: "absolute", marginBottom: "0px", bottom: "0" }}
              className="link-cursor-underline"
              onClick={this.OnCancel}
            >
              {label["Buttons.Cancel.Text"] !== undefined
                ? label["Buttons.Cancel.Text"]
                : "Cancel"}
            </Label>
            <Button
              style={{ float: "right", marginRight: "0px" }}
              className="btn-success btn-md"
              disabled={this.state.IsNextDisabled}
              onClick={() => {
                this.OnNext("4");
              }}
            >
              {label["ReportViewer.FindNextButtonText.Text"] !== undefined
                ? label["ReportViewer.FindNextButtonText.Text"]
                : "Next"}
            </Button>
            <Button
              style={{
                float: "right",
                marginLeft: "0px",
                display: this.state.IsFromReportSchedules ? "none" : "block",
              }}
              className="btn-gray btn-md"
              onClick={() => {
                this.goBack("2");
              }}
            >
              {label["ReportManagement.btnback.Text"] !== undefined
                ? label["ReportManagement.btnback.Text"]
                : "Back"}
            </Button>
          </Col>
        </FormGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
    UserPreference_response: state.userPreferencesRootReducer.UserPreference,
    OnPremises: state.authService.IsOnPremise,
    scheduleRecurrenceDetails:
      state.ScheduleReportRootReducer.RecurrenceReportslist,
    scheduleReportDetails: state.ScheduleReportRootReducer.ReportList,
    userHasFullaccess: state.authService.HasApplicationFullAcess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllResources: () => dispatch(getAllResources()),
    getSchedulesRecurrenceList: (report_ID) =>
      dispatch(getSchedulesRecurrenceList(report_ID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportRecurrence);
